// src/store/loading.js
import Vue from 'vue'
import Vuex from 'vuex'
// Rimuovi questa riga: import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const loadingStore = new Vuex.Store({
  state: {
    isLoading: false // Stato per il caricamento globale
  },
  mutations: {
    setLoading (state, status) {
      // Aggiungiamo i log che ti avevo suggerito per un debug più dettagliato
      state.isLoading = status
    }
  },
  getters: {
    isLoading: (state) => state.isLoading
  }
  // Rimuovi completamente la sezione plugins
  /*
  plugins: [
    createPersistedState({
      key: 'appLoadingState',
      storage: window.sessionStorage,
      paths: ['isLoading']
    })
  ]
  */
})

export default loadingStore
